import { Component } from "react";

// ★ 2026-10-22 배포로 예전 화면 조각(chunk)이 서버에서 사라지면, 오래 열어 둔 앱·탭은 다른 화면으로 갈 때
//  조각을 못 받아 이 안내가 떴다(새로고침하면 정상). 조각 로드 실패면 안내 대신 한 번 자동으로 새로고침한다.
//  같은 경로에서 30초 안에 다시 실패하면(진짜 네트워크 문제) 반복 새로고침하지 않고 안내를 보인다.
const RELOAD_KEY = "muyeon.chunkReloadAt";
const isChunkError = (error) => /ChunkLoadError|Loading (CSS )?chunk|dynamically imported module|Importing a module script failed/i
  .test(`${error?.name || ""} ${error?.message || ""}`);

function reloadOnceFor(path) {
  try {
    const prev = JSON.parse(sessionStorage.getItem(RELOAD_KEY) || "null");
    if (prev && prev.path === path && Date.now() - prev.at < 30000) return false;
    sessionStorage.setItem(RELOAD_KEY, JSON.stringify({ path, at: Date.now() }));
  } catch (e) { /* 저장 못 하면 그래도 한 번은 새로고침 */ }
  window.location.reload();
  return true;
}

export default class RouteChunkBoundary extends Component {
  state = { failed: false, reloading: false };
  static getDerivedStateFromError(error) { return { failed: true, reloading: isChunkError(error) }; }
  componentDidCatch(error) {
    if (!isChunkError(error) || !reloadOnceFor(window.location.pathname)) this.setState({ reloading: false });
  }
  componentDidUpdate(previous) {
    if (previous.routeKey !== this.props.routeKey && this.state.failed) this.setState({ failed: false, reloading: false });
  }
  render() {
    if (!this.state.failed) return this.props.children;
    if (this.state.reloading) return null; // 곧 새로고침된다 — 안내를 깜빡 보이지 않는다
    return <div className="page" role="alert" style={{ padding: "3rem 2rem" }}>
      <p>화면을 불러오지 못했어요. 연결을 확인한 뒤 다시 시도해 주세요.</p>
      <button type="button" className="btn-md filled primary" onClick={() => window.location.reload()}>새로고침</button>
    </div>;
  }
}
